import Index from '@tunnel-components/@sharded/@widgets/dataPicker/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/dataPicker/index.ts